import React, { Fragment } from "react"
import PropTypes from "prop-types"

import Card from "ui/components/Card"
import Table from "ui/components/Table"
import Text from "ui/components/Text"
import Container from "ui/components/Container"

import Attribute from "features/records/components/Attribute"

import WithStacks from "data/wrappers/WithStacks"

const AppTable = props => {
    const columns = [
        {
            accessor: "name",
            Header: "Name",
            Cell: cell => (
                <Attribute
                    onChange={value => {
                        props.onChange(cell.original._sid, { name: value })
                    }}
                    editable
                    inline
                >
                    {cell.value}
                </Attribute>
            ),
        },
        {
            accessor: "url",
            Header: "URL",
            Cell: cell => (
                <Container className="table-no-ellipsis">
                    <WithStacks>
                        {({ selectedStack }) => (
                            <Fragment>
                                <Text margin="none" light inline>
                                    {selectedStack.base_url}
                                </Text>
                                <span style={{ width: 4 }} />
                            </Fragment>
                        )}
                    </WithStacks>
                    <Attribute
                        onChange={value => {
                            props.onChange(cell.original._sid, { url: value })
                        }}
                        editable
                        inline
                    >
                        {cell.value}
                    </Attribute>
                </Container>
            ),
        },
    ]

    return (
        <Card>
            <Table columns={columns} data={props.data} dataLabel="apps" />
        </Card>
    )
}

AppTable.propTypes = {
    data: PropTypes.arrayOf(PropTypes.object),
}
export default AppTable



// WEBPACK FOOTER //
// ./src/features/studio/components/AppTable.js